
$.widget("ui.fullGallery", {
	options: {
		previous : 'Previous',
		next: 'Next',
		album: 'Album',
		loader: 'galleryLoaderBig',
		closeLabel: 'Press Esc to close',
		containerID: '',
		externalGalleryID: '',
		goTo: [],
		templates: {},
		galleries: [],
		discounts: {},
		cacheImage: document.createElement('img'),
		onNavigateClickCallbacks: [],
		onCloseClickCallbacks: [],
	},
	_create: function() {
		var self = this, o = this.options;
		self._loadTemplates();
		if(typeof(o.galleries) == 'string') {
			$.getJSON(o.galleries, '', function(data) {
				o.galleries = data;
				self._render();
			});
		}else if(o.galleries.length == 0) {
			self.element.hide();
		} else {
			self._render();
		}
	},
	_loadTemplates: function() {
		var gallery_large = '<div class="galleryImage"> \
				<div class="galleryImageSlider"><a href="javascript:;" class="galleryImageSliderNext">'+this.options.next+'<span class="arrowRight"></span></a><a href="javascript:;" class="galleryImageSliderPrevious"><span class="arrowLeft"></span>'+this.options.previous+'</a><span class="albumLabel">'+this.options.album+'</span><div class="galleryLabelNumberWrap"><span class="galleryImageSliderNumber">1/1</span></div></div>  \
				<div class="galleryImageLargeContainer">  \
					<div class="galleryImageSliderNext big"><span class="right"></span></div> \
					<div class="galleryImageLarge"><img /></div> \
					<div id="'+this.options.loader+'"></div> \
					<div class="galleryImageSliderPrevious big"><span class="left"></span></div> \
				</div>  \
			</div>';

		var thumb_holder = '<div class="galleryThumbs clearfix" tabindex="0"></div>';

		var close_button = '<a id="closeFullScr" title="'+this.options.closeLabel+'">'+this.options.closeLabel+'</a>';

		if(!this.options.templates['gallery_large'])
		{
			this.options.templates.gallery_large = gallery_large;
		}
		if(!this.options.templates['thumb_holder'])
		{
			this.options.templates.thumb_holder = thumb_holder;
		}
		if(!this.options.templates['close_button'])
		{
			this.options.templates.close_button = close_button;
		}
	},
	_render: function() {
		var self = this, o = this.options, thumbs;
		$(o.templates.close_button).appendTo(this.element).tooltip().click(function(){ self._closeFullScr(); });

		this.element.prop('id', o.containerID);
		$(o.templates.gallery_large).appendTo(this.element);

		thumbs = $(o.templates.thumb_holder).prependTo(this.element);
		o.thumbs = thumbs;

		$.each(o.galleries, function(index, value)
		{
			var rawInfo = value.rawInfo;
			if(value.showDiscount == false)
			{
				value.discount = 'hide';
			} else {
				value.discount = 'show';
			}
			if (!value.discount) {
				value.discount='hide';
			}

			var mainContainer = $('<div />').addClass('galleryThumb').appendTo(thumbs);

			var thumbContainer = $('<div />').addClass('galleryThumbContainer').addClass('thumb'+index).data('image_index', 0).appendTo(mainContainer);

			if (value.images.length > 1) {
				$('<div />').addClass('galleryThumbAlbum').appendTo(thumbContainer);
			}
			var	thumbTitle = $('<div />').addClass('galleryThumbTitle').html('<span class="galleryThumbName">'+value.name+'</span>').appendTo(thumbContainer);
			var thumbLink = $('<a href="javascript:;" />').addClass('imageLink').data('index', index).data('discount', value.discount).appendTo(thumbContainer);
			var thumbImage = null;
			if(rawInfo) {
				if(rawInfo.size && !(value.view)) {
					$('<span />').addClass('galleryThumbArea').html('(' + rawInfo.size + ')').appendTo(thumbTitle);
				}
			}
			thumbImage = $('<img />').prop('src', value.images[0].thumb).appendTo(thumbLink);
			thumbImage.prop('alt', value.images[0].alt).prop('title', value.images[0].title);
			const thumbNavigation = $('<div />').addClass('galleryThumbNavigation');
			$('<span class="galleryThumbNumber" />').html('1/'+value.images.length).appendTo(thumbNavigation);
			thumbNavigation.appendTo(thumbContainer);

		});
		if (o.discounts) {
			$.each(o.discounts, function(index, discount) {
				$('<span />').prop('class', discount.cssClass).addClass('discount').append(discount.valueTrans).prependTo($('#'+o.containerID+' .galleryImageLarge'));
			});
		}

		o.thumbContainers = self.element.find('.galleryThumbContainer');

		self._loadGallery();
		return this;
	},
	_loadGallery: function() {
		var self = this, o = this.options;
		var image = '';
		o.theLoader = $('#'+o.loader);

		if (o.goTo.length != 0) {
			self.element.data('gallery_index', o.goTo['gallery_index']);
			self.element.data('image_index', o.goTo['image_index']);
			image = o.galleries[o.goTo['gallery_index']].images[o.goTo['image_index']].xtraLarge ? o.galleries[o.goTo['gallery_index']].images[o.goTo['image_index']].xtraLarge : o.galleries[o.goTo['gallery_index']].images[o.goTo['image_index']].large;
		} else {
			if (o.galleries[0].show != 0) {
					image = o.galleries[0].images[0].xtraLarge ? o.galleries[0].images[0].xtraLarge : o.galleries[0].images[0].large;
					self.element.data('gallery_index', 0);
			} else {
				$.each(o.galleries, function(key, value) {
					if (value.show != 0) {
						$.image = o.galleries[key].images[0].xtraLarge ? o.galleries[key].images[0].xtraLarge : o.galleries[key].images[0].large;
						self.element.data('gallery_index', key);
						return false;
					}
				});
				image = $.image;
			}
			self.element.data('image_index', 0);
			self.element.data('discount', 'show');
		}

		self._activateKeys();
		o.jspAPI = o.thumbs.jScrollPane().data('jsp');
		o.externalGallery = $('#'+o.externalGalleryID);
		o.cookie = 'fs_gallery_info';

		o.largeImage = self.element.find(".galleryImageLarge > img");
		o.largeImage.load(function() {
			self._setSelected();
			o.theLoader.hide();
		});

		self._goTo(self.element.data('gallery_index'), self.element.data('image_index'), image);
		self._checkNextImg(true);
		o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge ?  o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge :  o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].large;

		self.element.find('.galleryImageSliderPrevious').click(function(event) {
			event.preventDefault();
			o.theLoader.show();
			self._prevImg();
			self._setImageSliderNumber();
			self._setGalleryInfo();
		});

		self.element.find('.galleryImageSliderNext').click(function(event) {
			event.preventDefault();
			o.theLoader.show();
			self._nextImg();
			self._setImageSliderNumber();
			self._setGalleryInfo();
		});

		self.element.find('.imageLink').click(function(event) {
			o.theLoader.show();
			const thumbImageLink = $(this);
			const thumbContainer = thumbImageLink.parent();
			const thumbImage = thumbImageLink.children('img');
			const thumbNumber = thumbContainer.find('.galleryThumbNumber');
			if(thumbImageLink.data('index') != self.element.data('gallery_index'))
			{
				thumbContainer.data('image_index', thumbContainer.data('image_index') -1);
			}
			if(thumbContainer.data('image_index') == o.galleries[thumbImageLink.data('index')].images.length -1)
			{
				thumbContainer.data('image_index', -1);
			}
			thumbContainer.data('image_index', thumbContainer.data('image_index') + 1);
			thumbImage.prop('src', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['thumb']);
			thumbImage.prop('alt', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['alt']);
			thumbImage.prop('title', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['title']);
			thumbNumber.html((thumbContainer.data('image_index')+1)+'/'+o.galleries[thumbImageLink.data('index')].images.length);
			o.largeImage.prop('src', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['xtraLarge'] ? o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['xtraLarge'] : o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['large']);
			o.largeImage.prop('alt', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['alt']);
			o.largeImage.prop('title', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['title']);
			self.element.data('gallery_index', thumbImageLink.data('index'));
			self.element.data('image_index', thumbContainer.data('image_index'));
			self.element.data('discount', thumbImageLink.data('discount'));
			if(o.largeImage[0].complete) {o.largeImage.trigger('load');}
			self._setImageSliderNumber();
			self._setGalleryInfo();
			self._checkNextImg(true);
			o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge ? o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge : o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].large;
		});
	},
	_checkPrevImg: function(preload) {
		var self = this, o = this.options;

		var gallery_index = 'gallery_index',
			image_index = 'image_index';

		if (preload) {
			self.element.data('preload_gallery_index', self.element.data('gallery_index'));
			self.element.data('preload_image_index', self.element.data('image_index'));
			gallery_index = 'preload_gallery_index';
			image_index = 'preload_image_index';
		}

		if(self.element.data(image_index) == 0){
			let n;
			if(self.element.data(gallery_index) == 0)
			{
				n = o.galleries.length-1;
			}else{
				n = self.element.data(gallery_index)-1;
			}
			let i;
			for(i=n;i>=0;i--)
			{
				self.element.data(gallery_index,i);
				if(o.galleries[self.element.data(gallery_index)].show != "0"){
					break;
				}
			}
			// Zašto se "i" koristi van petlje? :(
			self.element.data(image_index, o.galleries[i]['images'].length-1);
		}else
		{
			self.element.data(gallery_index, self.element.data(gallery_index));
			self.element.data(image_index, self.element.data(image_index)-1);
		}
	},
	_prevImg: function() {
		var self = this, o = this.options;

		self._checkPrevImg();
		o.largeImage.prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].xtraLarge ? o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].xtraLarge : o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].large);
		o.largeImage.prop('alt', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].alt);
		o.largeImage.prop('title', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].title);
		o.thumbContainers.each(function(index, value)
		{
			if($(value).children('.imageLink').data('index') == self.element.data('gallery_index'))
			{
				self.element.data('discount',$(value).children('.imageLink').data('discount'));
				$(value).data('image_index', self.element.data('image_index'));
				$(value).find('.imageLink img').prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].thumb);
				$(value).find('.galleryThumbNumber').html((self.element.data('image_index')+1)+'/'+o.galleries[$(value).children('.imageLink').data('index')].images.length);
				return false;
			}
		});

		self._checkPrevImg(true); //cache prev image
		o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge ? o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge : o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].large;
	},
	_checkNextImg: function(preload) {
		var self = this, o = this.options;
		var gallery_index = 'gallery_index',
			image_index = 'image_index';

		if (preload) {
			self.element.data('preload_gallery_index', self.element.data('gallery_index'));
			self.element.data('preload_image_index', self.element.data('image_index'));
			gallery_index = 'preload_gallery_index';
			image_index = 'preload_image_index';
		}

		if (self.element.data(image_index) == o.galleries[self.element.data(gallery_index)].images.length -1) {
			if (self.element.data(gallery_index) == o.galleries.length -1) {
				if (o.galleries[0].show == 0) {
					$.each(o.galleries, function(key, value) {
						if (value.show != 0) {
							$.key = key;
							return false;
						}
					});
				} else {
					$.key = 0;
				}
				self.element.data(gallery_index, $.key);
			} else {
				for (var i=self.element.data(gallery_index);i<=o.galleries.length;i++) {
					self.element.data(gallery_index, self.element.data(gallery_index)+1);
					if (o.galleries[self.element.data(gallery_index)] == undefined) {
						self.element.data(gallery_index,0);
						break;
					} else if ( o.galleries[self.element.data(gallery_index)].show != false) {
						break;
					}

				}
			}

			self.element.data(image_index,0);
		} else {
			self.element.data(gallery_index, self.element.data(gallery_index));
			self.element.data(image_index, self.element.data(image_index) + 1);
		}
	},
	_nextImg: function() {
		var self = this, o = this.options;

		self._checkNextImg();
		o.largeImage.prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].xtraLarge ?  o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].xtraLarge :  o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].large);

		o.thumbContainers.each(function(index, value) {
			if ($(value).children('.imageLink').data('index') == self.element.data('gallery_index')) {
				self.element.data('discount',$(value).children('.imageLink').data('discount'));
				$(value).data('image_index', self.element.data('image_index'));
				$(value).find('.imageLink img').prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].thumb);
				$(value).find('.galleryThumbNumber').html((self.element.data('image_index')+1)+'/'+o.galleries[$(value).children('.imageLink').data('index')].images.length);
				return false;
			}
		});

		self._checkNextImg(true); //cache next image
		o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge ? o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].xtraLarge : o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].large;
	},
	_goTo: function(gIndex, iIndex, image) {
		var self = this, o = this.options;
		if (image === undefined) {
			self.element.data('gallery_index', gIndex);
			self.element.data('image_index', iIndex);
			image = o.galleries[gIndex].images[iIndex].xtraLarge;
		}
		o.largeImage.prop('src', image).trigger('load');

		o.thumbContainers.each(function(index, value)
		{
			if($(value).children('.imageLink').data('index') == gIndex)
			{
				self.element.data('discount',$(value).children('.imageLink').data('discount'));
				$(value).data('image_index', iIndex);
				$(value).find('.imageLink img').prop('src', o.galleries[gIndex].images[iIndex].thumb);
				$(value).find('.galleryThumbNumber').html((iIndex+1)+'/'+o.galleries[$(value).children('.imageLink').data('index')].images.length);
				return false;
			}
		});

		self._setImageSliderNumber();
		self._setGalleryInfo();
	},
	_setSelected: function() {
		var self = this, o = this.options;
		o.thumbContainers.removeClass('active');

		const activeThumb = self.element.find('.thumb'+self.element.data('gallery_index'));
		activeThumb.addClass('active');

		o.jspAPI.scrollToElement(activeThumb);
		self._executeNavigateCallbacks(o.onNavigateClickCallbacks);
	},
	_activateKeys: function() {
		var self = this, o = this.options;
		$(document).on('keydown.fullScrEvents', function(e) {
			if(e.keyCode == 37) { // left arrow
				e.preventDefault();
				o.theLoader.show();
				self._prevImg();
				self._setImageSliderNumber();
				self._setGalleryInfo();
			} else if (e.keyCode == 39) { // right arrow
				e.preventDefault();
				o.theLoader.show();
				self._nextImg();
				self._setImageSliderNumber();
				self._setGalleryInfo();
			}
		}).on('keyup.fullScrEvents', function(e) {
			if(e.keyCode == 27) {self._closeFullScr();} //escape
		});
	},
	_closeFullScr: function () {
		var self = this, o = this.options;
		$('body').removeClass('fullMode');
		self.element.removeClass('opened');
		$(document).off('.fullScrEvents');
		o.externalGallery.data('gallery')._goTo(self.element.data('gallery_index'), self.element.data('image_index'));
		self._executeCloseCallbacks(o.onCloseClickCallbacks);
	},
	_setImageSliderNumber: function () {
		var self = this, o = this.options;
		var numberOfImages = o.galleries[self.element.data('gallery_index')].images.length;
		var position = parseInt(this.element.data('image_index'), 10) + 1;
		this.element.find('.galleryImageSliderNumber').html('<span class="bold">' + o.galleries[this.element.data('gallery_index')].name + ' </span> <span class="albumPos">(' + position + '/' + numberOfImages + ')</span>');
	},
	_setGalleryInfo: function () {
		const self = this;
		var o = this.options;
        const partDescriptionRows = o.galleries[self.element.data('gallery_index')].partDescriptionRows;

        if (partDescriptionRows === undefined) {
            var info = o.galleries[self.element.data('gallery_index')].info;
        }

		if (self.element.data('discount') == 'hide') {
			self.element.addClass('noDiscount');
		} else if (self.element.data('discount') == 'show') {
			self.element.removeClass('noDiscount');
		}

		if(partDescriptionRows !== undefined && partDescriptionRows.length === 0) {
			self.element.find('.galleryImageInfo').hide();
			return false;
		} else if (partDescriptionRows === undefined && info == null || info == '') {
			self.element.find('.galleryImageInfo').hide();
			return false;
		} else {
			self.element.find('.galleryImageInfo').show();
		}

		if(self.element.find('.galleryImageInfo').length == 0) {
			var tmpCookie = $.cookie(o.cookie);

			$('<div class="galleryImageInfo"></div>').append(
				$('<div />').addClass(tmpCookie=='0'?'galleryImageIcons':'galleryImageIcons getIn').append(
					$('<a />').addClass(tmpCookie=='0'?'galInfo':'galInfoOff').click(function(event) {
						event.preventDefault();
						self.element.find('.imgDesc').slideToggle();
						$(this).toggleClass('galInfoOff galInfo').parent().toggleClass('getIn');
						$.cookie(o.cookie, $.cookie(o.cookie)=='0'?'1':'0', {path: '/', expires: 0});
					})
				)
			).append(
				$('<div class="imgDesc galleryImageDescription"></div>').css( "display", tmpCookie=='0' ? "none;" :"block")
			).prependTo(self.element.find('.galleryImageLargeContainer'));
		}

		if ($.cookie(o.cookie)=='0') {
			self.element.find('.imgDesc').hide();
		} else {
			self.element.find('.imgDesc').show();
		}

		const imageDescriptionElement = self.element.find('.imgDesc').html('');
		if (partDescriptionRows === 'undefined') {
            $.each(info, function(index, value) {
                if(index == 'heading') {
                    imageDescriptionElement.append($('<strong />').append(value)).append('<br />');
                } else {
                    $('<strong />').append(index).appendTo(imageDescriptionElement);

                    if(value) { imageDescriptionElement.append(': ' + value); }
                    imageDescriptionElement.append('<br />');
                }
            });
		} else {
	           partDescriptionRows.forEach(row => imageDescriptionElement.append(row).append('<br />'));
		}

	},
	_executeNavigateCallbacks: function (callbacks) {
	    callbacks.map(function (callback) {
	    	callback();
	    });
	},
	_executeCloseCallbacks: function (callbacks) {
	    callbacks.map(function (callback) {
	    	callback();
	    });
	}
});
